/**
 * Persist Operations Dashboard widget order (org + user scoped).
 */

import {
  DEFAULT_DASHBOARD_WIDGET_ORDER,
  resolveDashboardWidgetOrder,
} from "../config/dashboardWidgets";
import {
  readOrgScopedJson,
  resolveCacheOrganizationId,
  writeOrgScopedJson,
} from "./orgCacheStorage";

export const DASHBOARD_WIDGET_ORDER_CACHE_KEY = "CP_DASHBOARD_WIDGET_ORDER";

function buildActorBucketKey(actor) {
  return (
    actor?.supabase_user_id ||
    actor?.id ||
    actor?.user_id ||
    "anonymous"
  );
}

export function loadDashboardWidgetOrder(actor) {
  const organizationId = resolveCacheOrganizationId(actor);
  const stored = readOrgScopedJson(
    DASHBOARD_WIDGET_ORDER_CACHE_KEY,
    organizationId,
  );

  let savedOrder = null;
  if (Array.isArray(stored)) {
    savedOrder = stored;
  } else if (stored && typeof stored === "object") {
    const bucket = buildActorBucketKey(actor);
    savedOrder = stored[bucket] || stored.default || null;
  }

  return resolveDashboardWidgetOrder(savedOrder);
}

export function saveDashboardWidgetOrder(actor, order) {
  const organizationId = resolveCacheOrganizationId(actor);
  const resolved = resolveDashboardWidgetOrder(order);
  const bucket = buildActorBucketKey(actor);
  const existing =
    readOrgScopedJson(DASHBOARD_WIDGET_ORDER_CACHE_KEY, organizationId) || {};

  const next =
    existing && typeof existing === "object" && !Array.isArray(existing)
      ? { ...existing, [bucket]: resolved }
      : { [bucket]: resolved };

  writeOrgScopedJson(
    DASHBOARD_WIDGET_ORDER_CACHE_KEY,
    organizationId,
    next,
  );

  return resolved;
}

export function getDefaultDashboardWidgetOrder() {
  return [...DEFAULT_DASHBOARD_WIDGET_ORDER];
}
